import { useMutation } from "@tanstack/react-query";
import { AXIOS_HOSPITALITY, AXIOS_RESERVATION } from "../utils/axios-interceptors";

export const useGetReservationMutation = ({hId,wId}) => {
  console.log(hId, wId)
  return useMutation({
    mutationKey: ["reservation",hId, wId],
    mutationFn: async (data) => {
      const response = await AXIOS_RESERVATION.get(`/v1/reservations/web-check-in/${hId}/${wId}`);
      if(response.data.success){
        AXIOS_RESERVATION.interceptors.request.use((config) => {
          config.headers["hotelCode"] = response.data.result.data.hotelCode;
          config.headers["hotelId"] = response.data.result.data.hotelId;
          config.headers["reservationId"] = response.data.result.data.reservationId;
          return config;
        })
        AXIOS_HOSPITALITY.interceptors.request.use((config) => {
          config.headers["hotelCode"] = response.data.result.data.hotelCode;
          config.headers["hotelId"] = response.data.result.data.hotelId;
          config.headers["reservationId"] = response.data.result.data.reservationId;
          return config;
        })
      }
      return response.data;
    },
  });
};